"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createdUpdatedAggregator = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const field_logic_1 = require("../field-type-registry/field-logic");
const date_1 = require("../utils/date");
function createdUpdatedAggregator(aggregate) {
    return (0, field_logic_1.valuesAggregator)((values, logic, field, userPreferences) => {
        // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
        //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
        //  Move logic flatten to Lookup field logic
        const dates = (0, flattenDeep_1.default)(values).map((value) => {
            const date = {
                date: value.on,
                include_time: Boolean(field.params.include_time),
            };
            // momentDate always exists because date can't be null
            return {
                date,
                momentDate: (0, date_1.dateToMoment)(date, userPreferences),
            };
        });
        return aggregate(dates, field, userPreferences, "standard");
    });
}
exports.createdUpdatedAggregator = createdUpdatedAggregator;
